const schedulingUrl = process.env.REACT_APP_SCHEDULING_URL;

if (!schedulingUrl) {
  throw new Error("REACT_APP_SCHEDULING_URL is missing");
}

const allowedHosts = ["cal.com", "www.cal.com", "calendly.com", "www.calendly.com"];
const parsed = new URL(schedulingUrl);

if (parsed.protocol !== "https:" || !allowedHosts.includes(parsed.hostname)) {
  throw new Error("REACT_APP_SCHEDULING_URL must be an HTTPS Cal.com or Calendly URL");
}

export { schedulingUrl };
